// src/components/OverviewSelector.tsx

import React from 'react';
import { CustomSelect } from './CustomSelect';
import { ExtendedDropdownOption } from '../types/Dropdown';
import { AgentDescription } from '../types/AgentDescription';
import './OverviewSelector.scss';

interface OverviewSelectorProps {
  overviews: Array<{
    sender?: string;
    content: any;
  }>;
  selectedOverview: number;
  onOverviewChange: (index: number) => void;
}

export const OverviewSelector: React.FC<OverviewSelectorProps> = ({
  overviews,
  selectedOverview,
  onOverviewChange,
}) => {
  const options: ExtendedDropdownOption[] = overviews.map((overview, i) => ({
    value: i.toString(),
    label: overview.sender ? AgentDescription(overview.sender).name : `Thought ${i + 1}`,
    metadata: {
      // leftInfo: overview.content.action_title,
      rightInfo: `${i + 1}/${overviews.length} thought${overviews.length > 1 ? 's' : ''}`
    }
  }));

  return (
    <div className="overview-selector">
      <CustomSelect
        options={options}
        value={selectedOverview.toString()}
        onChange={(value) => onOverviewChange(value ? parseInt(value) : 0)}
        placeholder="Select overview"
        className="overview-select"
      />
    </div>
  );
};